module.exports = __webpack_public_path__ + "img/Aric.674c0134.png";